import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';

import getSubgroup from '../data/getSubgroup';
import getRepairs from '../data/getRepairs';
import getColumns from '../data/getColumns';

import RepairList from '../components/RepairList'

import InvoiceNoLabor from '../images/invoice_no_labor.png'
import InvoiceWithLabor from '../images/invoice_with_labor.png'



const styles = theme => ({
  root: {
    display: 'flex',
  },
  customizeButton: {
    marginTop: theme.spacing.unit * 0.7,
    marginBottom: theme.spacing.unit * 0.7,
    maxWidth: 235,
  },
  formControl: {
    paddingTop: theme.spacing.unit * 0.5,
    paddingBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit,
    borderRadius: theme.spacing.unit,
    border: '1px solid #ddd',
  },
  formLabel: {
  },
  columnLabel: {
    width: '3.5em',
  },
  centerVertically: {
    alignItems: 'center',
    display: 'flex',
  },
  columnCheckbox: {
    marginRight: -10,
    marginLeft: -4,
  },
  grow: {
    flexGrow: 1,
  },
});



class DisplayOptionsForm extends React.Component {

  // Defaults
  state = {
    displayBarcodes: false,
    displayTime: true,
    roundedPrices: true,
  }


  handleCheckbox = event => {
    const {order, actions} = this.props
    let data = {}
    data[event.target.value] = !order[event.target.value]
    actions.updateOrder(order, data)
  };


  render = () => {
    const {
      classes,
    } = this.props

    const { order, pricingMode } = this.props

    const {
      displayBarcodes,
      displayTime,
      roundedPrices,

      column1Highlighted,
      column2Highlighted,
      column3Highlighted,
      column4Highlighted,

      column1Printed,
      column2Printed,
      column3Printed,
      column4Printed,
    } = order


    if (pricingMode !== 'Legacy') {
      return (
        <Grid container>
          <Grid item xs={12} sm={4}>
            <FormControlLabel control={ <Checkbox checked={displayTime} onChange={this.handleCheckbox} value="displayTime" /> } label="Show Labor Times" />
          </Grid>
          <Grid item xs={12} sm={8}>
            <img alt="Invoice Preview" src={displayTime ? InvoiceWithLabor : InvoiceNoLabor} style={{width:'100%'}}/>
          </Grid>
        </Grid>
      )
    }

    return (
      <div>
        <Grid container>
          <Grid item xs={12} sm={5}>
            <FormLabel className={classes.formLabel} component="legend">Show:</FormLabel>
            <FormGroup component="fieldset" className={classes.formControl}>
              <FormControlLabel control={ <Checkbox checked={displayBarcodes} onChange={this.handleCheckbox} value="displayBarcodes" /> } label="Barcodes" />
              <FormControlLabel control={ <Checkbox checked={displayTime} onChange={this.handleCheckbox} value="displayTime" /> } label="Labor Times" />
              <FormControlLabel control={ <Checkbox checked={roundedPrices} onChange={this.handleCheckbox} value="roundedPrices" /> } label="Rounded Prices" />
            </FormGroup>
          </Grid>
          <Grid item xs={12} sm={7}>
            <FormLabel className={classes.formLabel} component="legend">Pricing Columns:</FormLabel>
            <FormGroup component="fieldset" className={classes.formControl}>
              <FormGroup row component="fieldset" className={classes.centerVertically}>
                <FormLabel component="legend" className={classes.columnLabel}>Shade:</FormLabel>
                <FormControlLabel control={ <Checkbox checked={column1Highlighted} onChange={this.handleCheckbox} value="column1Highlighted" className={classes.columnCheckbox} /> } label="1" />
                <FormControlLabel control={ <Checkbox checked={column2Highlighted} onChange={this.handleCheckbox} value="column2Highlighted" className={classes.columnCheckbox} /> } label="2" />
                <FormControlLabel control={ <Checkbox checked={column3Highlighted} onChange={this.handleCheckbox} value="column3Highlighted" className={classes.columnCheckbox} /> } label="3" />
                <FormControlLabel control={ <Checkbox checked={column4Highlighted} onChange={this.handleCheckbox} value="column4Highlighted" className={classes.columnCheckbox} /> } label="4" />
              </FormGroup>

              <FormGroup row component="fieldset" className={classes.centerVertically}>
                <FormLabel component="legend" className={classes.columnLabel}>Hide:</FormLabel>
                <FormControlLabel control={ <Checkbox checked={!column1Printed} onChange={this.handleCheckbox} value="column1Printed" className={classes.columnCheckbox} /> } label="1" />
                <FormControlLabel control={ <Checkbox checked={!column2Printed} onChange={this.handleCheckbox} value="column2Printed" className={classes.columnCheckbox} /> } label="2" />
                <FormControlLabel control={ <Checkbox checked={!column3Printed} onChange={this.handleCheckbox} value="column3Printed" className={classes.columnCheckbox} /> } label="3" />
                <FormControlLabel control={ <Checkbox checked={!column4Printed} onChange={this.handleCheckbox} value="column4Printed" className={classes.columnCheckbox} /> } label="4" />
              </FormGroup>
              <Button style={{visibility:"hidden"}} color="primary" className={classes.customizeButton} variant="outlined">
                Customize Headings
              </Button>
            </FormGroup>
          </Grid>
        </Grid>

        <FormLabel>Book Preview:</FormLabel>
        <RepairList
          subgroup={getSubgroup(order)}
          repairs={getRepairs(order)}
          columns={getColumns(order)}
        />
      </div>
    )
  }
}

DisplayOptionsForm.propTypes = {
  order: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  pricingMode: PropTypes.string,
};

export default withStyles(styles)(DisplayOptionsForm);
